import { IDispositionData } from 'views/ProFormaTable/types';
import { Format, RowValue } from '../../ExecutiveSummaryGenericTable/types';
import { OperationsMetricId } from '../../layout/metrics';
import { BlockResolver } from '../../layout/types';

const cell = (value: number | undefined, format: Format) => (): RowValue => ({ value, format });

export const proFormaOperationsResolver = (disposition: IDispositionData | undefined): BlockResolver<OperationsMetricId> => ({

    'effectiveGrossRevenue.untrended': cell(disposition?.totalEffectiveGrossRevenue?.untrended, 'currency'),
    'effectiveGrossRevenue.trended': cell(disposition?.totalEffectiveGrossRevenue?.trended, 'currency'),
    'effectiveGrossRevenue.sale': cell(disposition?.totalEffectiveGrossRevenue?.sale, 'currency'),

    'operatingExpenses.untrended': cell(disposition?.totalOperatingExpenses?.untrended, 'currency'),
    'operatingExpenses.trended': cell(disposition?.totalOperatingExpenses?.trended, 'currency'),
    'operatingExpenses.sale': cell(disposition?.totalOperatingExpenses?.sale, 'currency'),

    'netOperatingIncome.untrended': cell(disposition?.netOperatingIncome?.untrended, 'currency'),
    'netOperatingIncome.trended': cell(disposition?.netOperatingIncome?.trended, 'currency'),
    'netOperatingIncome.sale': cell(disposition?.netOperatingIncome?.sale, 'currency'),

    'capitalExpenditures.untrended': cell(disposition?.totalCapitalExpenditures?.untrended, 'currency'),
    'capitalExpenditures.trended': cell(disposition?.totalCapitalExpenditures?.trended, 'currency'),
    'capitalExpenditures.sale': cell(disposition?.totalCapitalExpenditures?.sale, 'currency'),

    'cashFlowFromOperations.untrended': cell(disposition?.cashFlowFromOperations?.untrended, 'currency'),
    'cashFlowFromOperations.trended': cell(disposition?.cashFlowFromOperations?.trended, 'currency'),
    'cashFlowFromOperations.sale': cell(disposition?.cashFlowFromOperations?.sale, 'currency'),

    'capRate.untrended': cell(disposition?.marketCapitalizationRate?.current, 'percentage'),
    'capRate.trended': cell(disposition?.marketCapitalizationRate?.trended, 'percentage'),
    'capRate.sale': cell(disposition?.marketCapitalizationRate?.onSale, 'percentage'),

    'valuation.untrended': cell(disposition?.stabilizedValue?.untrended, 'currency'),
    'valuation.trended': cell(disposition?.stabilizedValue?.trended, 'currency'),
    'valuation.sale': cell(disposition?.stabilizedValue?.sale, 'currency'),

    'percentOfTotalProjectCost.untrended': cell(disposition?.percentOfTotalProjectCost?.untrended, 'percentage'),
    'percentOfTotalProjectCost.trended': cell(disposition?.percentOfTotalProjectCost?.trended, 'percentage'),
    'percentOfTotalProjectCost.sale': cell(disposition?.percentOfTotalProjectCost?.sale, 'percentage'),

    'valuationPerUnit.untrended': cell(disposition?.stabilizedValuePerUnit?.untrended, 'currency'),
    'valuationPerUnit.trended': cell(disposition?.stabilizedValuePerUnit?.trended, 'currency'),
    'valuationPerUnit.sale': cell(disposition?.stabilizedValuePerUnit?.sale, 'currency'),
});
